<template>
    <span>
        <v-btn icon variant="text" :size="size" @click="showNotes = true" class="note-icon-btn">
            <v-icon :size="iconSize" :color="hasNotes ? 'green' : 'grey-lighten-1'">
                {{ hasNotes ? 'mdi-note-text' : 'mdi-note-text-outline' }}
            </v-icon>
            <v-tooltip activator="parent" location="top" :max-width="300">
                <template v-if="pinnedNote">
                    <div class="text-caption font-weight-bold mb-1">📌 Pinned Note</div>
                    <div class="text-caption">{{ pinnedNote.length > 120 ? pinnedNote.substring(0, 120) + '...' : pinnedNote }}</div>
                    <div v-if="noteCount > 1" class="text-caption text-grey mt-1">{{ noteCount }} total notes</div>
                </template>
                <template v-else-if="hasNotes">
                    {{ noteCount }} note{{ noteCount > 1 ? 's' : '' }}
                </template>
                <template v-else>Add a note</template>
            </v-tooltip>
        </v-btn>

        <NotesPanel v-if="showNotes" v-model="showNotes" :entity-type="entityType" :entity-id="entityId"
                    @notes-changed="onNotesChanged"/>
    </span>
</template>

<script setup>
import {ref, computed} from "vue";
import NotesPanel from "./NotesPanel.vue";

const props = defineProps({
    entityType: {type: String, required: true},
    entityId: {type: [Number, String], required: true},
    pinnedNote: {type: String, default: null},
    noteCount: {type: Number, default: 0},
    size: {type: String, default: 'x-small'},
    iconSize: {type: Number, default: 16},
});

const emit = defineEmits(['notesChanged']);
const showNotes = ref(false);
const hasNotes = computed(() => props.noteCount > 0);

const onNotesChanged = (count) => {
    emit('notesChanged', count);
};
</script>

<style scoped>
.note-icon-btn {
    opacity: 0.6;
    transition: opacity 0.2s;
}
.note-icon-btn:hover {
    opacity: 1;
}
</style>
